import {
  useDeleteMutation,
  useInsertMutation,
  useUpdateMutation,
} from '@supabase-cache-helpers/postgrest-react-query';

import { supabaseClient } from '@/utils/supabase-client';

export function useCreateRecipeTag() {
  return useInsertMutation(supabaseClient.from('recipe_tag'), ['id'], '*');
}

export function useCreateRecipeTagAssociation() {
  return useInsertMutation(
    supabaseClient.from('recipe_tag_association'),
    ['recipe_id', 'tag_id'],
    '*',
    {
      revalidateTables: [{ table: 'recipe_overview' }],
    },
  );
}

export function useDeleteRecipeTagAssociation() {
  return useDeleteMutation(
    supabaseClient.from('recipe_tag_association'),
    ['recipe_id', 'tag_id'],
    '*',
    {
      revalidateTables: [{ table: 'recipe_overview' }],
    },
  );
}

export function useDeleteRecipeTag() {
  return useDeleteMutation(supabaseClient.from('recipe_tag'), ['id']);
}

export function useUpdateRecipeTag() {
  return useUpdateMutation(supabaseClient.from('recipe_tag'), ['id'], '*');
}
